import { graphql } from '../../../gql';

export const GENERATE_POST_INSIGHT = graphql(`
  mutation generatePostInsight($postId: ID!) {
    generatePostInsight(postId: $postId) {
      reading
      generatedAt
      fromCache
    }
  }
`);
